<template>
  <el-drawer
    custom-class="drawer-custom-class"
    append-to-body
    :close-on-press-escape="false"
    :title="title + '管理'"
    size="640px"
    :visible.sync="visible"
    direction="rtl"
    @closed="onClosed">
    <div
      v-loading="loading"
      class="drawer-wrap">
      <div class="search-from">
        <div>
          <el-button
            v-if="enable"
            type="primary"
            @click="editItem({})">新增{{ title }}</el-button>
        </div>
        <el-input
          v-model="config.staffName"
          style="width: 240px"
          clearable=""
          :placeholder="'请输入' + title + '姓名'">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </div>
      <el-table
        v-loading="loading"
        border
        :data="list">
        <el-table-column
          :label="title + '账号'"
          width="120"
          prop="account"></el-table-column>
        <el-table-column
          :label="title + '姓名'"
          min-width="200"
          prop="staffName"></el-table-column>
        <el-table-column
          v-if="enable"
          label="操作"
          fixed="right"
          width="160">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="editItem(row)">修改</el-button>
            <el-button
              type="text"
              @click="deleteItem(row)">删除</el-button>
            <el-button
              type="text"
              @click="resetPwd(row)">密码重置</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="text-align: center;"
        :current-page="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </div>
    <warehouse-management-edit-modal
      ref="management"
      :operType="operType"
      :title1="title"
      @fetch="fetchList" />
  </el-drawer>
</template>
<script>
import Wms from '@/service/wms'
import WarehouseManagementEditModal from './warehouse-management-edit-modal.vue'
export default {
  name: 'WarehouseManagementModal',
  components: { WarehouseManagementEditModal },
  props: {
    enable: { type: Boolean, default: true },
    operType: { type: Number, default: 60 },
    title: { type: String, default: '' }
  },
  data() {
    return {
      visible: false,
      loading: false,
      config: { pageNum: 1, pageSize: 10, staffName: '', userType: 506 },
      list: [],
      total: 0
    }
  },
  methods: {
    resetPwd(row) {
      this.$confirm('您确定重置该账号的密码?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('account/resetpassword', {
            payload: { account: row.account },
            success: () => {
              this.loading = false
              this.$message.success('重置密码成功')
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    editItem(row) {
      const { staffId = null, staffName = '', account = '' } = row
      this.$refs.management.init({ staffId, staffName, account })
    },
    deleteItem(row) {
      this.$confirm(`此操作将永久删除该${this.title}, 是否继续?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Wms.deletestaff({ staffId: row.staffId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    onClosed() {
      this.config = { ...this.config, ...this.$options.data().config }
      this.total = 0
      this.list = []
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Wms.getstaffs({ ...this.config, operTypes: [this.operType] })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if (result === 0) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch() {
      this.fetchList()
      this.visible = true
    }
  }
}
</script>

